var React = require('react');

function ShadowMInline (props) {
    return React.createElement("svg",props,[React.createElement("g",{"filter":"url(#filter0_f)","key":0},React.createElement("ellipse",{"cx":"497.5","cy":"392.184","rx":"167.184","ry":"272.5","transform":"rotate(-90 497.5 392.184)","fill":"black"})),React.createElement("defs",{"key":1},React.createElement("filter",{"id":"filter0_f","x":"0","y":"-0.000244141","width":"995","height":"784.367","filterUnits":"userSpaceOnUse","colorInterpolationFilters":"sRGB"},[React.createElement("feFlood",{"floodOpacity":"0","result":"BackgroundImageFix","key":0}),React.createElement("feBlend",{"mode":"normal","in":"SourceGraphic","in2":"BackgroundImageFix","result":"shape","key":1}),React.createElement("feGaussianBlur",{"stdDeviation":"112.5","result":"effect1_foregroundBlur","key":2})]))]);
}

ShadowMInline.defaultProps = {"width":"995","height":"785","viewBox":"0 0 995 785","fill":"none"};

module.exports = ShadowMInline;

ShadowMInline.default = ShadowMInline;
